<template>
    <ValidationObserver class="mx-auto p-3" v-slot="{ invalid }">
      <form @submit.prevent="onSubmit">
        <div class="row mb-4">
          <div class="col">
            <h5 class="mb-2">Exigences</h5>
            <p class="small text-muted mb-2">Pour créer un nouveau mot de passe, vous devez remplir toutes les conditions suivantes:</p>
            <ul class="small text-muted pl-4 mb-0">
              <li>Minimum 4 caractères</li>
              <li>Au moins une lettre majuscule</li>
              <li>Au moins une lettre miniscule</li>
              <li>Au moins un chiffre</li>
            </ul>
          </div>
          <div class="col">
            <div class="form-group">
              <label>L'actuel mot de passe</label>
              <ValidationProvider name="Ancien" rules="required" v-slot="{ errors }">
                <input type="password" class="form-control rounded-0" v-model="payload.oldPassword" placeholder="Mot de passe actuel">
                <small class="form-text text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>Le nouveau mot de passe</label>
              <ValidationProvider name="Nouveau" rules="required|min:4|containsUppercase|containsLowercase|containsNumber" vid="password" v-slot="{ errors }">
                <input type="password" name="nouveau" class="form-control rounded-0" v-model="payload.newPassword" placeholder="Nouveau mot de passe">
                <small class="form-text text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>Confirmer le mot de passe</label>
              <ValidationProvider name="Comfirme" rules="required|confirmed:password" v-slot="{ errors }">
                <input type="password" name="confirme" class="form-control" v-model="payload.rptPassword" placeholder="Confirmer mot de passe">
                <small class="form-text text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="form-group d-flex justify-content-end">
          <button class="style_btn text-uppercase btn btn-primary rounded-0" :disabled="invalid" v-if="!loading">Valider</button>
        </div>
      </form>
    </ValidationObserver>
</template>

<script>
    export default {
        name: "PwdChange",
        props: {account: Object},
        data: () => ({loading: false, payload: {}, error: ''}),
        methods: {
            onSubmit() {
                this.loading = true;
                this.$store.dispatch('auth/change', this.payload)
                    .then(() => this.$swat.fire('Changement de mot de passe', 'Votre nouveau mot de passe a été prise en compte.').then(() => this.payload = {}))
                    .catch(({data}) => this.$swat.fire('Erreur de Connexion', (data.message || data.error_description) || 'Connexion échouée', 'error'))
                    .finally(() => this.loading = false);
            }
        },
    }
</script>

<style scoped>

</style>